import {
    MODAL_CALLBACK_SHOW,
    MODAL_CALLBACK_HIDE,
} from './../constants/constants';

const initialState = {
    visible: false,
    modalProps: {
        titleImage: '',
        titleText: '',
        body: '',
        okButtonText: 'Okay',
        okButtonEvent: () => { },
        cancelButtonText: ''
    }
}

const modalCallbackReducer = (state = initialState, action) => {
    switch (action.type) {
        case MODAL_CALLBACK_SHOW:
            return {
                visible: true,
                modalProps: action.modalProps
            }

        case MODAL_CALLBACK_HIDE:
            return initialState;

        default:
            return state
    }
}

export default modalCallbackReducer;